module.exports = __webpack_public_path__ + "media/sample.87356128.mp3";